import { Component, inject } from '@angular/core';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonToggle,
  IonToolbar
} from "@ionic/angular/standalone";
import { RouterLink } from "@angular/router";
import { Role } from "@core/models/roles.enum";
import { HasAnyRolesDirective } from "@shared/directives/auth/has-any-role.directive";
import { TranslatePipe } from "@ngx-translate/core";
import { AuthenticationService } from "@core/services/authentication.service";
import { DeveloperService } from "@core/services/developer.service";
import { FormsModule } from "@angular/forms";


interface MenuItem {
  icon: string;
  label: string;
  link: string;
  roles?: Role[];
}

@Component({
  selector: 'pkp-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  host: {class: 'flex-row gap-24'},
  standalone: true,
  imports: [IonMenu, IonContent, IonList, IonItem, IonLabel, IonIcon, RouterLink, IonMenuToggle, IonHeader, IonToolbar, IonButtons, IonImg, IonButton, HasAnyRolesDirective, TranslatePipe, IonToggle, FormsModule]
})
export class MenuComponent {
  authService = inject(AuthenticationService);
  devService = inject(DeveloperService);

  menu: MenuItem[] = [
    {
      icon: 'train-outline',
      label: 'travel-document.travel-card',
      link: '/travel-document',
      roles: [Role.client_locomotive_driver]
    },
    {
      icon: 'hourglass-outline',
      label: 'work-time.work-time',
      link: '/work-time',
      roles: [Role.client_locomotive_driver]
    },
    {
      icon: 'car-outline',
      label: 'trip.trip-log',
      link: '/trip',
      roles: [Role.client_user]
    },
    {
      icon: 'person-outline',
      label: 'profile.profile',
      link: '/profile'
    },
    {
      icon: 'log-out-outline',
      label: 'login.logout',
      link: '/logout'
    },
  ] as MenuItem[];

}
